import React, { useState, useEffect } from 'react';
import { fetchBackgrounds } from '../shared/api';

const BackgroundPicker = ({ backgroundSetId, onSelect, onClose }) => {
  const [backgrounds, setBackgrounds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!backgroundSetId) { setBackgrounds([]); setLoading(false); return; }
    setLoading(true);
    fetchBackgrounds(backgroundSetId)
      .then(data => { setBackgrounds(data); setLoading(false); })
      .catch(err => { console.error(err); setLoading(false); });
  }, [backgroundSetId]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,.5)', zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: 8, padding: 20,
          width: 400, maxHeight: '80vh', display: 'flex', flexDirection: 'column'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#333' }}>
            Choose Background
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#999' }}
          >
            &times;
          </button>
        </div>

        {!backgroundSetId && (
          <div style={{ padding: 20, textAlign: 'center', color: '#999', fontSize: 13 }}>
            No background set assigned to this pricelist. Select a pricelist with a background set first.
          </div>
        )}

        {loading && backgroundSetId && (
          <div style={{ padding: 20, textAlign: 'center', color: '#999', fontSize: 12 }}>Loading backgrounds...</div>
        )}

        {!loading && backgrounds.length === 0 && backgroundSetId && (
          <div style={{ padding: 20, textAlign: 'center', color: '#999', fontSize: 12 }}>No backgrounds found in this set.</div>
        )}

        {/* Scrollable 4-across grid */}
        {backgrounds.length > 0 && (
          <div style={{ flex: 1, overflow: 'auto', paddingRight: 4 }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 8
            }}>
              {backgrounds.map(bg => (
                <div
                  key={bg.id}
                  onClick={() => onSelect(bg.id, bg.image_url)}
                  title={bg.color || bg.letter}
                  style={{
                    aspectRatio: '1',
                    borderRadius: 6,
                    border: '2px solid #e0e0e0',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    background: bg.image_url ? `url(${bg.image_url}) center/cover` : '#eee',
                    transition: 'border-color .15s'
                  }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#1976d2'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = '#e0e0e0'}
                >
                  {!bg.image_url && (
                    <div style={{
                      width: '100%', height: '100%', display: 'flex',
                      alignItems: 'center', justifyContent: 'center',
                      fontSize: 12, color: '#666'
                    }}>
                      {bg.letter || bg.color}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Clear button */}
        <button
          onClick={() => onSelect(null, null)}
          style={{
            marginTop: 12, width: '100%', padding: '8px', fontSize: 12,
            background: '#fff', border: '1px solid #ddd', borderRadius: 4,
            cursor: 'pointer', color: '#666'
          }}
        >
          Clear Background
        </button>
      </div>
    </div>
  );
};

export default BackgroundPicker;
